class BaseShopifyStorefrontClient {
    constructor(endpoint, accessToken) {
        this.endpoint = endpoint;
        this.accessToken = accessToken;
    }

    async executeQuery(query, variables = {}) {
        const body = JSON.stringify({ query, variables });

        const headers = {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': this.accessToken
        };

        try {
            const response = await fetch(this.endpoint, {
                method: 'POST',
                headers: headers,
                body: body
            });

            if (!response.ok) {
                throw new Error(`HTTP Error! Status: ${response.status}`);
            }

            const result = await response.json();

            if (result.errors) {
                throw new Error(`GraphQL Error! ${JSON.stringify(result.errors)}`);
            }

            return result.data;
        } catch (error) {
            console.error('GraphQL Query Error:', error);
            throw error;
        }
    }

    async executeMutation(mutation, variables = {}) {
        return this.executeQuery(mutation, variables);
    }
}

class ShopifyStorefrontClient extends BaseShopifyStorefrontClient {
  async getProductMetafield(handle, namespace, key) {
    const query = `
      query getProductMetafield($handle: String!, $namespace: String!, $key: String!) {
        productByHandle(handle: $handle) {
          metafield(namespace: $namespace, key: $key) {
            id
            namespace
            key
            value
          }
        }
      }
    `;

        const variables = { handle, namespace, key };
        return await this.executeQuery(query, variables);
    }

    async getPostcodeMetaobject(handle, type) {
        const query = `
      query getProductMetafield($handle: String!, $type: String!) {
        metaobject(handle:{handle: $handle, type: $type}) {
          fields{
            key
            value
          }
        }
      }
    `;

        const variables = { handle, type };
        return await this.executeQuery(query, variables);
    }

    async getProductVariantStoreAvailability(handle, lat, long, name, value, first) {
        const query = `
      query getProductVariantStoreAvailability($handle: String!, $lat: Float!, $long: Float!, $name: String!, $value: String!, $first: Int!) {
        product(handle: $handle) {
          variantBySelectedOptions(selectedOptions: {name: $name, value: $value}) {
            storeAvailability(near: {latitude: $lat, longitude: $long}, first: $first) {
              nodes {
                available
                quantityAvailable
                location {
                  name
                  address {
                    address1
                    address2
                    city
                    phone
                    province
                    zip
                  }
                }
              }
            }
          }
        }
      }
    `;

        const variables = { handle, lat, long, name, value, first };
        return await this.executeQuery(query, variables);
    }
}

window.ShopifyStorefrontClient = ShopifyStorefrontClient;